module.exports = __webpack_public_path__ + "img/icon_48.e54c29b0.png";